import { Flex, Text, ToggleButtonGroup, ToggleButton } from '@backstage/ui';
import { RiCodeSSlashLine } from '@remixicon/react';
import { useSearch } from '@backstage/plugin-search-react';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../../core/i18n';
import styles from './search-type-filter.module.css';

const typeOptions = [
  { id: 'software-catalog', icon: RiCodeSSlashLine, labelKey: 'search.softwareCatalog' as const },
];

export const SearchTypeFilter = () => {
  const { types, setTypes } = useSearch();
  const { t } = useTranslationRef(appTranslationRef);

  return (
    <Flex direction="column" gap="2">
      <Text variant="body-x-small" color="secondary" weight="bold" className={styles.sectionLabel}>
        {t('search.resultType')}
      </Text>
      <ToggleButtonGroup
        selectedKeys={new Set(types)}
        onSelectionChange={keys => {
          setTypes(Array.from(keys) as string[]);
        }}
        selectionMode="single"
        orientation="vertical"
      >
        {typeOptions.map(option => {
          const Icon = option.icon;
          return (
            <ToggleButton
              key={option.id}
              id={option.id}
              iconStart={<Icon size={16} />}
            >
              {t(option.labelKey)}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </Flex>
  );
};
